import { EstadoFP, FirmPro } from "../utils/interfaces";
import parseTime from "../utils/parseTime";


/**
 * generateFirmPros procesa data, un arreglo de estados por equipo FirmPro.
 * Por cada equipo, genera los datos que se deben mostrar en la página:
 * el color de las cajas (MeterBox), y qué texto deben mostrar. Toda esa
 * información se guarda en un nuevo arreglo de objetos
 * 
 * @param {EstadoFP[]} Los estados de los equipos FirmPro.
 * @returns {FirmPro[]} Arreglo de información de FirmPro que se mostrará en el
 * semáforo.
 */
export default function generateFirmPros(status: EstadoFP[]): FirmPro[] {
  return status.map(status => {
    /*
    Ejemplo de contenido de FirmProBox:

    9000. Andinexia      (boxHeading)
    2/3/2023, 15:10:59    (boxTime)
    */
    const boxTime = parseTime(status.tiempo);

    const subBoxBGColors = ["", "", "", ""];
    const subBoxTooltips = ["", "", "", ""];
    const issuesList = [status.falla_servidor, status.falla_hardware, status.falla_software, status.falla_usuario, status.falla_comercial];
    const typesList = ["servidor", "hardware", "software", "usuario", "comercial"];

    let numCriticalIssues = 0;
    let numWarnings = 0;

    // Por cada posible tipo de falla, se asignan colores a la caja del equipo
    // FirmPro.
    for (let i = 0; i < issuesList.length; i++) {
      const maybeFalla = issuesList[i];
      if (maybeFalla === null) {
        subBoxBGColors[i] = "white";
        if (typesList[i] === "comercial") {
          subBoxTooltips[i] = "No hay problemas comerciales.";
        } else {
          subBoxTooltips[i] = `No hay problemas de ${typesList[i]}.`;
        }
        continue;
      }
      
      const falla = maybeFalla;
      if (falla.es_critica) {
        subBoxBGColors[i] = "red.400";
        numCriticalIssues++;
      } else if (typesList[i] === "servidor") {
        subBoxBGColors[i] = "gray.400";
        numWarnings++;
      } else {
        subBoxBGColors[i] = "yellow.400";
        numWarnings++;
      }

      subBoxTooltips[i] = `${parseTime(falla.tiempo)} - ${falla.mensaje_falla}`;
    }

    const boxBGColor = (
      status.falla_servidor !== null
      ? "gray.500"
      : numCriticalIssues > 0
      ? "red.500"
      : numWarnings > 0
      ? "yellow.500"
      : "green.500"
    );
    
    // Objeto con todos los datos del dispositivo a mostrar en la página
    return {
      nfp: status.nfp,
      nombre_fp: status.nombre_fp || "[Sin nombre]",

      boxBGColor: boxBGColor,
      boxTime: boxTime,

      subBoxBGColors: subBoxBGColors,
      subBoxTooltips: subBoxTooltips,

      enableAlarms: true,

      numCriticalIssues: numCriticalIssues,
      numWarnings: numWarnings,
    };
  });
}